import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getLocalized, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import { createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import {
	deleteDisciplines,
	listDisciplines,
	readDiscipline
} from "../../redux/actions/table/superadmin/disciplines";
import DisciplinesFlyout from "../../flyouts/superadmin/disciplines/DisciplinesFlyout";
import TableNA from "../../components/TableNA";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_disciplines"],
	application_language_id: state.auth.language_id,
}))
class Disciplines extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_discipline && setPlusActions([{
			title: "Add discipline",
			onClick: () => setTableParams('superadmin_disciplines', {
				add_discipline_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readDiscipline(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false,
			}, {
				key: "code",
				name: "Code",
				value: code => getLocalized(code, application_language_id),
				width: 60,
			}, {
				key: "name",
				name: "Name",
				required: true,
				value: name => getLocalized(name, application_language_id)
			}, {
				key: "profession",
				name: "Profession",
				width: 300,
				value: profession => getLocalized(profession, application_language_id)
			},
		];

		const singleActions = (discipline_id) => {
			return [
				<Tooltip text="Delete selected discipline" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected discipline?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteDisciplines([discipline_id]).then(() => {
												hideAlertbox();

												setNotification("The selected discipline has been deleted.");
												listDisciplines();

												setTableParams('superadmin_disciplines', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (disciplines_ids) => [
			<Tooltip text="Delete selected disciplines" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these disciplines?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteDisciplines(disciplines_ids).then(() => {
											hideAlertbox();

											setNotification("The selected disciplines have been deleted.");
											listDisciplines();

											setTableParams('superadmin_disciplines', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<DisciplinesFlyout
				data={this.state.preview}
				readAction={discipline_id => {
					return new Promise(resolve => {
						readDiscipline(getURLParam('id') || discipline_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listDisciplines}
				name="superadmin_disciplines"
				groupActions={superadmin.delete_discipline && groupActions}
				singleActions={superadmin.delete_discipline && singleActions}
				title={__("modules.submodules.title.disciplines")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default Disciplines;
